export const PLATFORM_RECENT_APPS_KEY = "tm.platform.recentApps";
export const PLATFORM_PINNED_APPS_KEY = "tm.platform.pinnedApps";
export const PLATFORM_APP_USAGE_KEY = "tm.platform.appUsage";

export const PLATFORM_RECENT_APPS_LIMIT = 10;

